import React, { useEffect, useState } from 'react';

const HINT_MESSAGES = [
  '궁금한 사항을 물어보세요',
  '탄소관리·배출권, AI에게 물어보세요',
  '배출량 산정 방법이 궁금하신가요?',
  '클릭하면 AI 챗봇이 열려요',
];

const ROTATE_INTERVAL_MS = 8000;

export const RESPONSE_READY_MESSAGE = 'AI 답변이 도착했습니다. 클릭해서 확인하세요';

interface AiChatHintBubbleProps {
  readonly visible: boolean;
  /** 지정 시 안내 문구 순환 대신 고정 메시지 표시 */
  readonly message?: string;
}

/**
 * AI 챗봇 최초 이용 전 아이콘 옆에 안내 멘트를 말풍선으로 순환 표시한다.
 * 답변 완료 알림 시 message prop으로 고정 문구를 표시한다.
 */
export default function AiChatHintBubble({ visible, message }: AiChatHintBubbleProps) {
  const [messageIndex, setMessageIndex] = useState(0);
  const isFixedMessage = Boolean(message);

  useEffect(() => {
    if (!visible || isFixedMessage) {
      return;
    }
    const timerId = globalThis.setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % HINT_MESSAGES.length);
    }, ROTATE_INTERVAL_MS);
    return () => globalThis.clearInterval(timerId);
  }, [visible, isFixedMessage]);

  if (!visible) {
    return null;
  }

  const displayText = message ?? HINT_MESSAGES[messageIndex];

  return (
    <div
      className={`ai-chat-hint-bubble${isFixedMessage ? ' ai-chat-hint-bubble--notice' : ''}`}
      role="status"
      aria-live="polite"
    >
      <p key={isFixedMessage ? message : messageIndex} className="ai-chat-hint-bubble__text">
        {displayText}
      </p>
    </div>
  );
}

export const AI_CHAT_OPENED_STORAGE_PREFIX = 'ys-ai-chat-opened';

/**
 * 사용자별 AI 챗봇 최초 오픈 여부 localStorage 키를 반환한다.
 */
export function getAiChatOpenedStorageKey(userId: string): string {
  return `${AI_CHAT_OPENED_STORAGE_PREFIX}:${userId}`;
}

/**
 * 해당 사용자가 AI 챗봇을 한 번이라도 열었는지 확인한다.
 */
export function hasUserOpenedAiChat(userId: string): boolean {
  return localStorage.getItem(getAiChatOpenedStorageKey(userId)) === '1';
}

/**
 * AI 챗봇 최초 오픈 상태를 저장한다.
 */
export function markAiChatOpened(userId: string): void {
  localStorage.setItem(getAiChatOpenedStorageKey(userId), '1');
}
